var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrapSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.039,
    viewBox: "0 0 20 16.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10117",
    "data-name": "Group 10117",
    transform: "translate(-9070 -9906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "align-justify",
    transform: "translate(9068 9901)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x1: 18,
    transform: "translate(3 10)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x1: 18,
    transform: "translate(3 6)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x1: 11,
    transform: "translate(3 14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x1: 9,
    transform: "translate(3 18)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "corner-down-left",
    transform: "translate(9080 9910.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8798",
    "data-name": "Path 8798",
    d: "M6.3,10,4,12.3l2.3,2.3",
    transform: "translate(-1 -4.218)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8799",
    "data-name": "Path 8799",
    d: "M9,4V6.645A1.4,1.4,0,0,1,7.75,8.157H4",
    transform: "translate(0 -0.075)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapSel);
export default __webpack_public_path__ + "static/media/wrap_sel.7e2a1887.svg";
export { ForwardRef as ReactComponent };